module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break c"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy x"
  }, [_vm._v("Copyright © 2022 Matthew E. Sheets")]), _vm._v(" "), _c('p', {
    staticClass: "copy x"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copy x"
  }, [_vm._v("No part of this book may be reproduced, stored in a retrieval system, or transmitted by any means, electronic, mechanical, photocopying, recording, or otherwise, without written permission from the author.")]), _vm._v(" "), _c('p', {
    staticClass: "copy z"
  }, [_vm._v("ISBN: 978-1-63302-224-9")]), _vm._v(" "), _c('p', {
    staticClass: "copy z"
  }, [_vm._v("ISBN: 978-1-63302-228-7 (eBook)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a9e3118","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/02_copyright.vue
// module id = 60
// module chunks = 0